module.exports = __webpack_public_path__ + "img/azure.5de31e1b.svg";